// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"4447e7b6","453":"db3c7b0c","455":"6e54cbb9","977":"f13726f5"}[chunkId] + ".chunk.js";
};